import * as RestApi from 'core/network/RestApi';
import { ISftpUserResetPasswordData, ISftpUserUpdatePermissionsData } from 'sections/user-management/entities';

export const resetSftpUserPassword = (sftpUser: ISftpUserResetPasswordData) => {
  return RestApi.put(`/public_sftp_users/${sftpUser.username}/reset_password`, sftpUser);
};

export const updateSftpPermissions = (sftpUser: ISftpUserUpdatePermissionsData) => {
  return RestApi.put(`/public_sftp_users/${sftpUser.username}/permissions`, sftpUser);
};
